export enum FieldsEnum {
  password = 'password',
  confirmPassword = 'confirmPassword',
}
